import React from 'react';
import SpinnersContainer from '../../Componant/UiKits/Spinners';

const Spinner = () => {
  return (
    <div className='page-body'>
      <SpinnersContainer />
    </div>
  );
};

export default Spinner;
